import React from 'react';
import classNames from 'classnames';
const Skeleton = ({ lines, type, width, theme, standalone }) => {
    const elements = [];
    const styles = {};
    if (width) {
        styles.width = typeof width === 'number' ? `${width}%` : width;
    }
    for (let i = 0; i < lines; i++) {
        const skeletonLine = (<div className={classNames('skeleton', { 'skeleton--dark': theme === 'dark' }, 'skeleton-text')} key={i} style={styles}/>);
        elements.push(skeletonLine);
    }
    if (type === 'text') {
        return elements.length > 1 ? <div>{elements}</div> : <>{elements}</>;
    }
    return (<div className={classNames('skeleton-wrapper', `skeleton-wrapper--${type}`, {
            'skeleton-standalone': standalone,
        })}>
            {elements}
        </div>);
};
Skeleton.defaultProps = {
    lines: 1,
    type: 'text',
    standalone: true,
    width: null,
    theme: 'light',
};
export default Skeleton;
